import { render } from "./EventHostView.vue?vue&type=template&id=2ac86dc6&scoped=true"
import script from "./EventHostView.vue?vue&type=script&lang=js"
export * from "./EventHostView.vue?vue&type=script&lang=js"

import "./EventHostView.vue?vue&type=style&index=0&id=2ac86dc6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ac86dc6"]])

export default __exports__